import type { AnonymousLimitError } from '../types';

export function stringValue(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}

export function numberValue(value: unknown): number | undefined {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim()) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
  }
  return undefined;
}

export function agentReadyWithTimeout(agentReady: Promise<void>, timeoutMs = 5000): Promise<void> {
  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(() => {
      reject(new Error('Agent connection timed out'));
    }, timeoutMs);

    agentReady
      .then(() => resolve())
      .catch(reject)
      .finally(() => window.clearTimeout(timeout));
  });
}

export function normalizeAgentHost(serverUrl: string): string | undefined {
  if (!serverUrl) return undefined;

  try {
    return new URL(serverUrl).host;
  } catch {
    return serverUrl
      .replace(/^https?:\/\//, '')
      .replace(/^wss?:\/\//, '')
      .replace(/\/$/, '');
  }
}

export function isAbortOrCancelMessage(content: string): boolean {
  const normalized = content.trim().toLowerCase();
  return (
    normalized === 'the operation was aborted' ||
    normalized === 'response generation was cancelled.'
  );
}

export function isAnonymousLimitMetadata(metadata: unknown): metadata is AnonymousLimitError {
  if (!metadata || typeof metadata !== 'object') return false;

  const error = (metadata as { error?: unknown }).error;
  return (
    error === 'ANONYMOUS_LIMIT_EXCEEDED' ||
    error === 'Anonymous session limit exceeded' ||
    error === 'Anonymous message limit exceeded'
  );
}
